(function (global) {
  'use strict';

  function addBusinessDays(date, count) {
    var result = new Date(date);
    var added = 0;

    while (added < count) {
      result.setDate(result.getDate() + 1);
      if (result.getDay() !== 0 && result.getDay() !== 6) added += 1;
    }

    return result;
  }

  function getRange(now) {
    var reference = now instanceof Date ? now : new Date();

    return {
      start: addBusinessDays(reference, 4),
      end: addBusinessDays(reference, 8),
    };
  }

  function format(now, locale) {
    var range = getRange(now);
    var formatter = new Intl.DateTimeFormat(locale || 'fr', {
      day: 'numeric',
      month: 'long',
    });

    if (typeof formatter.formatRange === 'function') {
      return formatter.formatRange(range.start, range.end);
    }

    return formatter.format(range.start) + ' – ' + formatter.format(range.end);
  }

  function formatStart(now, locale) {
    var language = String(locale || 'fr').toLowerCase().split('-')[0];
    if (language !== 'fr') return '';

    var range = getRange(now);
    var weekday = new Intl.DateTimeFormat(locale || 'fr', {
      weekday: 'long',
    }).format(range.start);

    return weekday + ' prochain';
  }

  function render(root) {
    if (!root || typeof root.querySelectorAll !== 'function') return;

    var locale =
      root.documentElement?.lang ||
      global.document?.documentElement?.lang ||
      'fr';
    var now = new Date();
    var value = format(now, locale);
    var startValue = formatStart(now, locale);

    root.querySelectorAll('[data-lpc-delivery-window]').forEach(function (node) {
      node.textContent = value;
    });
    root.querySelectorAll('[data-lpc-delivery-start]').forEach(function (node) {
      node.textContent = startValue;
    });
  }

  global.LpcDeliveryWindow = {
    addBusinessDays: addBusinessDays,
    getRange: getRange,
    format: format,
    formatStart: formatStart,
    render: render,
  };
  if (
    typeof global.dispatchEvent === 'function' &&
    typeof global.CustomEvent === 'function'
  ) {
    global.dispatchEvent(new global.CustomEvent('lpc:delivery-window-ready'));
  }

  if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        render(document);
      });
    } else {
      render(document);
    }

    new MutationObserver(function (mutations) {
      var containsDeliveryWindow = mutations.some(function (mutation) {
        return Array.prototype.some.call(mutation.addedNodes, function (node) {
          return (
            node.nodeType === 1 &&
            (node.matches?.('[data-lpc-delivery-window], [data-lpc-delivery-start]') ||
              node.querySelector?.('[data-lpc-delivery-window], [data-lpc-delivery-start]'))
          );
        });
      });

      if (containsDeliveryWindow) render(document);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})(typeof window !== 'undefined' ? window : globalThis);
